/** Íconos de trazo, los mismos del prototipo. Decorativos: siempre aria-hidden. */

type P = { tam?: number; color?: string };

/** La corona de MentorKing: la misma del ícono del navegador (public/icono.svg). */
export const Marca = ({ tam = 26 }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#2A241C" />
    <path d="M12 47V20l11 11 9-17 9 17 11-11v27z" fill="#D9B45F" />
    <path d="M32 33l4.5 5-4.5 5-4.5-5z" fill="#2A241C" />
  </svg>
);

export const FlechaIzq = ({ tam = 14, color = '#6B5F52' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="M8.6 3 4.6 7l4 4" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const FlechaDer = ({ tam = 14, color = '#6B5F52' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="M5.4 3l4 4-4 4" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Reloj = ({ tam = 16, color = '#6B5F52' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <circle cx="8" cy="8" r="6.4" stroke={color} strokeWidth="1.3" />
    <path d="M8 5v3.4l2.2 1.4" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Escudo = ({ tam = 16, color = '#6B5F52' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M8 1.9l5.1 2v4c0 3-2.1 5.4-5.1 6.6-3-1.2-5.1-3.6-5.1-6.6v-4z" stroke={color} strokeWidth="1.3" strokeLinejoin="round" />
    <path d="M6 8.1l1.5 1.5 2.9-3" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Sobre = ({ tam = 24, color = '#85682E' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2.8" y="5.4" width="18.4" height="13.2" rx="2.2" stroke={color} strokeWidth="1.6" />
    <path d="m3.8 6.8 8.2 6 8.2-6" stroke={color} strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

export const Check = ({ tam = 28, color = '#FFFFFF' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <path d="M7.5 14.6l4.3 4.3 8.7-9.4" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Cruz = ({ tam = 24, color = '#9C4A34' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.6" />
    <path d="M9 9l6 6M15 9l-6 6" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const Candado = ({ tam = 24, color = '#9C4A34' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="4.5" y="10" width="15" height="10" rx="2" stroke={color} strokeWidth="1.6" />
    <path d="M8 10V7.5a4 4 0 0 1 8 0V10" stroke={color} strokeWidth="1.6" />
  </svg>
);

export const Camara = ({ tam = 16, color = '#FFFFFF' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect x="2" y="4" width="8.4" height="8" rx="1.4" stroke={color} strokeWidth="1.4" />
    <path d="M10.4 7.2 14 5.2v5.6l-3.6-2z" stroke={color} strokeWidth="1.4" strokeLinejoin="round" />
  </svg>
);

export const Tarjeta = ({ tam = 16, color = '#FFFFFF' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect x="1.8" y="3.4" width="12.4" height="9.2" rx="1.6" stroke={color} strokeWidth="1.4" />
    <path d="M1.8 6.6h12.4" stroke={color} strokeWidth="1.4" />
  </svg>
);

export const Mas = ({ tam = 15, color = '#1F1A16' }: P) => (
  <svg width={tam} height={tam} viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="M7 2.6v8.8M2.6 7h8.8" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
